import { render } from "./RegistrationEmail.vue?vue&type=template&id=a9baa31e&scoped=true&ts=true"
import script from "./RegistrationEmail.vue?vue&type=script&lang=ts"
export * from "./RegistrationEmail.vue?vue&type=script&lang=ts"

import "./RegistrationEmail.vue?vue&type=style&index=0&id=a9baa31e&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9baa31e"]])

export default __exports__